import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "core/gd-components/base-component/base-component";

import { when } from 'simply-deferred';

// Good article
// https://dev.to/pulljosh/how-to-load-html-css-and-js-code-into-an-iframe-2blc

class ModalOriginalEmail extends BaseComponent {

    constructor(props) {
        super(props);
    }


    componentDidMount() {


        const getGeneratedPageURL = ({ html, css, js }) => {

            const getBlobURL = (code, type) => {
                const blob = new Blob([code], { type });
                return URL.createObjectURL(blob)
            };

            // const cssURL = getBlobURL(css, 'text/css');
            // const jsURL = getBlobURL(js, 'text/javascript');

            const source = `
${html || ''}
  `;

            return getBlobURL(source, 'text/html')
        };

        const url = getGeneratedPageURL({
            html: this.props.email.source_html
        });

        const iframe = document.querySelector('#originalEmail');
        iframe.src = url;



    }



    render() {
        return (
            <iframe id="originalEmail"></iframe>
        );
    }
}

module.exports = ModalOriginalEmail;